import isEqual from "lodash/isEqual";
import { z } from "zod";

import { encodeCompressed } from "lib/hooks/useURLState";
import { routes } from "lib/routes";
import { NoticeSemanticColumnField } from "lib/types/savedViews";
import { DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS } from "./noticeSemanticColumns";
import { DEFAULT_FILTERS, NoticeV2FiltersSchema } from "./utils";

/** Partial filter input merged with defaults via `NoticeV2FiltersSchema` (same as Notices V2 URL state). */
export type NoticeV2UrlFiltersInput = z.input<typeof NoticeV2FiltersSchema>;

/**
 * Structured `{ to, search }` target for `/noticesv2` with `noticeSemanticFilters`/`noticeSemanticColumns`
 * set to compressed JSON, matching `useNoticesV2UrlState` encoding so the page hydrates the same filters.
 * Omits each param when equal to defaults, same as `setFilters`.
 */
export function noticesV2TargetWithFilters(
  filterOverrides: NoticeV2UrlFiltersInput,
  columns?: NoticeSemanticColumnField[],
): { to: string; search?: Record<string, unknown> } {
  const filters = NoticeV2FiltersSchema.parse(filterOverrides);
  const search: Record<string, unknown> = {};
  if (!isEqual(filters, DEFAULT_FILTERS)) {
    const encoded = encodeCompressed(filters);
    if (typeof encoded === "string") {
      search.noticeSemanticFilters = encoded;
    }
  }
  if (columns !== undefined && !isEqual(columns, DEFAULT_NOTICE_SEMANTIC_COLUMN_FIELDS)) {
    const encoded = encodeCompressed(columns);
    if (typeof encoded === "string") {
      search.noticeSemanticColumns = encoded;
    }
  }
  return { to: routes.noticesV2, search: Object.keys(search).length > 0 ? search : undefined };
}
